module.exports = __webpack_public_path__ + "static/media/logo-vertical.45b5b173.svg";